"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Carousel = void 0;
var _ChevronLeft = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = _interopRequireDefault(require("../../fuse-typography-element/src/typography"));
var _config = require("./config");
var _styledCarousel = require("./styled-carousel");
var _excluded = ["children", "chevronOverlay", "dataTestId", "title", "gridAreaOverride", "gridContainerPadding", "touchPeek", "columnGapSize", "responsiveTitle", "xxsCardsPerPage", "mCardsPerPage", "lCardsPerPage", "xxsOverrides", "mOverrides", "lOverrides", "componentId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var useState = _react["default"].useState,
  useRef = _react["default"].useRef,
  useEffect = _react["default"].useEffect,
  useMemo = _react["default"].useMemo,
  memo = _react["default"].memo;
var OverridesPropType = _propTypes["default"].shape({
  slides: _propTypes["default"].number.isRequired,
  gridItemSize: _propTypes["default"].number.isRequired
});
var propTypes = {
  xxsCardsPerPage: _propTypes["default"].number,
  mCardsPerPage: _propTypes["default"].number,
  lCardsPerPage: _propTypes["default"].number,
  xxsOverrides: OverridesPropType,
  mOverrides: OverridesPropType,
  lOverrides: OverridesPropType,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  chevronOverlay: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string.isRequired,
  gridAreaOverride: _propTypes["default"].bool,
  gridContainerPadding: _propTypes["default"].bool,
  responsiveTitle: _propTypes["default"].bool,
  touchPeek: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  columnGapSize: _propTypes["default"].shape({
    xxs: _propTypes["default"].oneOf(_config.columnGapRange.xxs),
    m: _propTypes["default"].oneOf(_config.columnGapRange.m),
    l: _propTypes["default"].oneOf(_config.columnGapRange.l),
    xl: _propTypes["default"].oneOf(_config.columnGapRange.xl)
  }),
  componentId: _propTypes["default"].string
};
var defaultProps = {
  xxsCardsPerPage: 2,
  mCardsPerPage: 4,
  lCardsPerPage: 5,
  xxsOverrides: undefined,
  mOverrides: undefined,
  lOverrides: undefined,
  chevronOverlay: false,
  gridAreaOverride: false,
  gridContainerPadding: true,
  responsiveTitle: false,
  touchPeek: true,
  title: '',
  columnGapSize: undefined,
  componentId: (0, _fuseUtils.uuid)()
};
/* istanbul ignore next */ /* jest cant emulate intersectionobserver */
var prevSlide = function prevSlide(slideContainer) {
  slideContainer.scrollLeft -= slideContainer.offsetWidth;
};
/* istanbul ignore next */ /* jest cant emulate intersectionobserver */
var nextSlide = function nextSlide(slideContainer) {
  slideContainer.scrollLeft += slideContainer.offsetWidth;
};
/* istanbul ignore next */ /* jest cant emulate intersectionobserver */
var pipSlide = function pipSlide(slideContainer, pipIndex, currentPage) {
  if (currentPage === pipIndex) return;
  slideContainer.scrollLeft += slideContainer.offsetWidth * (pipIndex - currentPage);
};
function AccessibilityInstructions(_ref) {
  var currentPage = _ref.currentPage,
    totalSlides = _ref.totalSlides;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Use the right and left arrows to scroll through the image carousel"), /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Page ", currentPage + 1, " of ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "SrOnlyXxs"
  }, totalSlides.xxs), /*#__PURE__*/_react["default"].createElement("span", {
    className: "SrOnlyM"
  }, totalSlides.m), /*#__PURE__*/_react["default"].createElement("span", {
    className: "SrOnlyL"
  }, totalSlides.l)));
}
AccessibilityInstructions.propTypes = {
  currentPage: _propTypes["default"].number.isRequired,
  totalSlides: _propTypes["default"].object.isRequired
};
AccessibilityInstructions.defaultProps = {};

/**
 *
 * @type {React.FC<import('../../fuse').CarouselProps>}
 */
var Carousel = exports.Carousel = memo(function (_ref2) {
  var children = _ref2.children,
    chevronOverlay = _ref2.chevronOverlay,
    dataTestId = _ref2.dataTestId,
    title = _ref2.title,
    gridAreaOverride = _ref2.gridAreaOverride,
    gridContainerPadding = _ref2.gridContainerPadding,
    touchPeek = _ref2.touchPeek,
    columnGapSize = _ref2.columnGapSize,
    responsiveTitle = _ref2.responsiveTitle,
    xxsCardsPerPage = _ref2.xxsCardsPerPage,
    mCardsPerPage = _ref2.mCardsPerPage,
    lCardsPerPage = _ref2.lCardsPerPage,
    xxsOverrides = _ref2.xxsOverrides,
    mOverrides = _ref2.mOverrides,
    lOverrides = _ref2.lOverrides,
    componentId = _ref2.componentId,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var slideContainer = useRef();
  var timeoutList = useRef({});
  var totalSlides = useMemo(function () {
    var _xxsOverrides$slides, _mOverrides$slides, _lOverrides$slides;
    var len = children.length;
    return {
      xxs: (_xxsOverrides$slides = xxsOverrides === null || xxsOverrides === void 0 ? void 0 : xxsOverrides.slides) !== null && _xxsOverrides$slides !== void 0 ? _xxsOverrides$slides : Math.ceil(len / xxsCardsPerPage),
      m: (_mOverrides$slides = mOverrides === null || mOverrides === void 0 ? void 0 : mOverrides.slides) !== null && _mOverrides$slides !== void 0 ? _mOverrides$slides : Math.ceil(len / mCardsPerPage),
      l: (_lOverrides$slides = lOverrides === null || lOverrides === void 0 ? void 0 : lOverrides.slides) !== null && _lOverrides$slides !== void 0 ? _lOverrides$slides : Math.ceil(len / lCardsPerPage)
    };
  }, [children.length, lCardsPerPage, lOverrides === null || lOverrides === void 0 ? void 0 : lOverrides.slides, mCardsPerPage, mOverrides === null || mOverrides === void 0 ? void 0 : mOverrides.slides, xxsCardsPerPage, xxsOverrides === null || xxsOverrides === void 0 ? void 0 : xxsOverrides.slides]);
  var gridItemSizes = useMemo(function () {
    var _xxsOverrides$gridIte, _mOverrides$gridItemS, _lOverrides$gridItemS;
    return {
      xxs: (_xxsOverrides$gridIte = xxsOverrides === null || xxsOverrides === void 0 ? void 0 : xxsOverrides.gridItemSize) !== null && _xxsOverrides$gridIte !== void 0 ? _xxsOverrides$gridIte : Math.ceil(12 / xxsCardsPerPage),
      m: (_mOverrides$gridItemS = mOverrides === null || mOverrides === void 0 ? void 0 : mOverrides.gridItemSize) !== null && _mOverrides$gridItemS !== void 0 ? _mOverrides$gridItemS : Math.ceil(12 / mCardsPerPage),
      l: (_lOverrides$gridItemS = lOverrides === null || lOverrides === void 0 ? void 0 : lOverrides.gridItemSize) !== null && _lOverrides$gridItemS !== void 0 ? _lOverrides$gridItemS : Math.ceil(10 / lCardsPerPage)
    };
  }, [lCardsPerPage, lOverrides === null || lOverrides === void 0 ? void 0 : lOverrides.gridItemSize, mCardsPerPage, mOverrides === null || mOverrides === void 0 ? void 0 : mOverrides.gridItemSize, xxsCardsPerPage, xxsOverrides === null || xxsOverrides === void 0 ? void 0 : xxsOverrides.gridItemSize]);

  /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
  var handleTabIntersection = function handleTabIntersection(entries) {
    entries.forEach(function (entry) {
      // tabindex for buttons and links
      if (entry.isIntersecting) {
        entry.target.tabIndex = 0;
        entry.target.inert = false;
        // entry.target.dataset.ariaCurrent = 'location';
      } else {
        entry.target.tabIndex = -1;
        entry.target.inert = true;
        // entry.target.dataset.ariaCurrent = null;
      }
    });
  };

  /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
  var handlePageIntersection = function handlePageIntersection(entries) {
    entries.forEach(function (entry) {
      // set current page
      if (entry.isIntersecting) {
        timeoutList.current[entry.target.id] = setTimeout(function () {
          setCurrentPage(Number(entry.target.dataset.currentPage));
        }, 50);
      } else {
        clearTimeout(timeoutList.current[entry.target.id]);
      }
    });
  };
  useEffect(function () {
    var options = {
      root: slideContainer.current,
      rootMargin: '0px',
      threshold: 0.99
    };
    var tabIndexIntersectionObserver = new IntersectionObserver(handleTabIntersection, options);
    var pageIntersectionObserver = new IntersectionObserver(handlePageIntersection, options);
    slideContainer.current.querySelectorAll(".fuse-carousel__carousel-snap-section").forEach(function (target) {
      return pageIntersectionObserver.observe(target);
    });
    slideContainer.current.querySelectorAll(".focusable > *").forEach(function (target) {
      return tabIndexIntersectionObserver.observe(target);
    });
    return function () {
      tabIndexIntersectionObserver.disconnect();
      pageIntersectionObserver.disconnect();
    };
  }, [handlePageIntersection, handleTabIntersection]);
  return /*#__PURE__*/_react["default"].createElement(_styledCarousel.CarouselContainer, _extends({
    "data-testid": dataTestId
  }, props), /*#__PURE__*/_react["default"].createElement(_styledCarousel.StyledGridContainer, {
    className: "container",
    gridContainerPadding: gridContainerPadding
  }, /*#__PURE__*/_react["default"].createElement(_styledCarousel.CarouselLayout, {
    chevronOverlay: chevronOverlay,
    title: title,
    gridAreaOverride: gridAreaOverride
  }, /*#__PURE__*/_react["default"].createElement(AccessibilityInstructions, {
    currentPage: currentPage,
    totalSlides: totalSlides
  }), title && /*#__PURE__*/_react["default"].createElement(_grid.GridItem, {
    xxs: 12,
    l: chevronOverlay ? 12 : 11,
    style: {
      gridArea: 'title'
    }
  }, /*#__PURE__*/_react["default"].createElement(_typography["default"], {
    type: "heading",
    size: responsiveTitle ? {
      xxs: '3',
      m: '4',
      l: '5'
    } : 't2',
    tag: "h2"
  }, title)), /*#__PURE__*/_react["default"].createElement(_styledCarousel.ButtonContainer, {
    xxs: 0,
    l: chevronOverlay ? 0 : 1,
    style: {
      gridArea: 'prev'
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledCarousel.CarouselButton, {
    className: gridAreaOverride ? "fuse-carousel__button-previous" : ""

    /* jest cant emulate intersectionobserver */,
    onClick: /* istanbul ignore next */function onClick() {
      return prevSlide(slideContainer.current);
    },
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null),
    "data-testid": "".concat(dataTestId, "-previous"),
    disabled: currentPage === 0
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Previous slide"))), /*#__PURE__*/_react["default"].createElement(_grid.GridItem, {
    xxs: 12,
    l: chevronOverlay ? 12 : 10,
    style: {
      gridArea: 'slides',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledCarousel.OverflowContainer, {
    id: "".concat(dataTestId),
    chevronOverlay: chevronOverlay,
    touchPeek: touchPeek,
    ref: slideContainer
  }, chevronOverlay && /*#__PURE__*/_react["default"].createElement(_styledCarousel.ChevronOverlayButton
  /* jest cant emulate intersectionobserver */, {
    onClick: /* istanbul ignore next */function onClick() {
      return prevSlide(slideContainer.current);
    },
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null),
    "data-testid": "".concat(dataTestId, "-previous"),
    disabled: currentPage === 0,
    position: "left"
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Previous slide")), /*#__PURE__*/_react["default"].createElement(_styledCarousel.SlideContentContainer, {
    xxsSlides: totalSlides.xxs,
    mSlides: totalSlides.m,
    lSlides: totalSlides.l,
    chevronOverlay: chevronOverlay,
    touchPeek: touchPeek,
    columnGapSize: columnGapSize
  }, /*#__PURE__*/_react["default"].createElement(_styledCarousel.CarouselItemGrid, {
    xxsSlides: totalSlides.xxs,
    mSlides: totalSlides.m,
    lSlides: totalSlides.l,
    chevronOverlay: chevronOverlay,
    role: "list",
    columnGapSize: columnGapSize
  }, _toConsumableArray(Array(totalSlides.xxs).keys()).map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_styledCarousel.CarouselSnapSection, {
      key: item,
      id: "slide-".concat(index, "-").concat(componentId),
      chevronOverlay: chevronOverlay,
      "data-current-page": index,
      role: "listitem"
    });
  }), _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].createElement(_grid.GridItem, {
      xxs: gridItemSizes.xxs,
      m: chevronOverlay ? 12 : gridItemSizes.m,
      l: chevronOverlay ? 12 : gridItemSizes.l,
      className: "grid-item focusable fuse-carousel__grid-item-children",
      role: "listitem"
    }, child);
  }))), chevronOverlay && /*#__PURE__*/_react["default"].createElement(_styledCarousel.ChevronOverlayButton
  /* jest cant emulate intersectionobserver */, {
    onClick: /* istanbul ignore next */function onClick() {
      return nextSlide(slideContainer.current);
    },
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    "data-testid": "".concat(dataTestId, "-next"),
    disabled: currentPage === totalSlides.l - 1,
    position: "right"
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Next slide")))), /*#__PURE__*/_react["default"].createElement(_styledCarousel.ButtonContainer, {
    xxs: 0,
    l: chevronOverlay ? 0 : 1,
    style: {
      gridArea: 'next'
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledCarousel.CarouselButton, {
    className: gridAreaOverride ? "fuse-carousel__button-next" : ""
    /* jest cant emulate intersectionobserver */,
    onClick: /* istanbul ignore next */function onClick() {
      return nextSlide(slideContainer.current);
    },
    icon: /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null),
    "data-testid": "".concat(dataTestId, "-next"),
    disabled: currentPage === totalSlides.l - 1
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Next slide"))), /*#__PURE__*/_react["default"].createElement(_styledCarousel.PipContainer, {
    mSlides: totalSlides.m,
    lSlides: totalSlides.l,
    style: {
      gridArea: 'pips'
    }
  }, _toConsumableArray(Array(totalSlides.xxs).keys()).map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_styledCarousel.Pip, {
      key: item,
      role: "button",
      className: currentPage === index && "current",
      "data-testid": "".concat(dataTestId, "-slide-").concat(index),
      "aria-current": currentPage === index
      /* jest cant emulate intersectionobserver */,
      onClick: /* istanbul ignore next */function onClick() {
        return pipSlide(slideContainer.current, index, currentPage);
      }
    }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "Go to page ", index + 1));
  })))));
}, /* istanbul ignore next */ /* jest cant emulate intersectionobserver */
function (prevProps, newProps) {
  return prevProps === newProps;
});
Carousel.displayName = 'FuseCarousel';
Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
var _default = exports["default"] = Carousel;